export default "__VITE_ASSET__CF3dEC8x__"